module.exports = __webpack_public_path__ + "static/media/brain_dots.025cbd1d.svg";